const year = (new Date()).getFullYear() + 2;

export const carYears = Array.from(new Array(74),(val, index) => year - index);

export default {
  carYears,
};
